import { useModal } from '@wrisk/ui-components'
import React, { FunctionComponent } from 'react'
import { useNavigate, useResolvedPath } from 'react-router'

import {
  useAccountValidation,
  usePolicyholderAdjustment,
} from '../../../../../hooks/adjustments/policyholder'
import {
  TExtends,
  TKey,
  useWriskTranslation,
} from '../../../../../infrastructure/internationalisation'
import { useUpButton } from '../../../../../infrastructure/routing'
import { usePolicyholder } from '../../../../authentication'
import { FormErrors } from '../../../../formBuilder'
import { FullPage } from '../../../../templates'
import { useProduct } from '../../../productContext'
import { useCheckout } from '../CheckoutProvider'
import { SignInModalContent } from './components/SignInModalContent'

const tKey = TKey('pages.account-setup')

export const AccountSetupPage: FunctionComponent = () => {
  const { t } = useWriskTranslation()

  const navigate = useNavigate()
  const modal = useModal()

  const { previous, next } = useCheckout()
  const { product } = useProduct()

  const { policyholder } = usePolicyholder()

  const resolvedPath = useResolvedPath(next.url)
  const upButton = useUpButton(previous)

  const onUseSubmitAccountSetupAdjustment = useAccountValidation(
    () => navigate(next.url),
    () => {
      modal.show({
        content: <SignInModalContent returnTo={resolvedPath.pathname} />,
      })
    },
  )

  const onSubmitAdjustment = usePolicyholderAdjustment(
    onUseSubmitAccountSetupAdjustment.execute,
  )

  return (
    <FullPage
      pageId='account-setup'
      header={t(tKey('header'))}
      subheader={t(tKey('subheader'))}
      upButton={upButton}
    >
      <FormErrors
        id='accountSetup'
        key='policy'
        data={policyholder ?? {}}
        config={product.accountSetup}
        onSubmit={onSubmitAdjustment.execute}
        loading={onSubmitAdjustment.loading}
        tKey={TExtends(tKey, 'form')}
        t={t}
      />
    </FullPage>
  )
}
